import React, {Component} from 'react';
import LGif from "../../assets/images/loading.gif"
import NoNet from "../../assets/images/nonet.webp"

class Loading extends Component {
    state = {
        delay: 0
    }
    render() {
        return (
            <section className="loading max-w-lg">

                {
                    this.state.delay !== 1 ?  <div className="loading-content">
                            <img src={LGif} alt="loading"/>
                            <div className="loading-text">
                                در حال بارگزاری
                            </div>
                        </div>
                        :
                    <div className="reloading mt-5 p-3">
                        <img src={NoNet} alt="عدم ارتباط با سرور"/>
                        <p className='text-primary-color fw-bold px-3'>
                           متاسفانه ارتباط با سرور برقرار نشد.

                            <div className='text-secondary-color pt-2'>از اینکه به اینترنت متصل هستید مطمئن شوید و دوباره تلاش کنید.</div>
                        </p>
                        <div>
                            <button className='btn btn-warning w-75 mt-3' onClick={() => {window.location.reload()}}>
                                تلاش مجدد
                            </button>
                        </div>
                    </div>
                }
            </section>
        );
    }
    componentDidMount() {
        setTimeout (() => {
           this.setState({delay : 1})
        },6000)
    }
}

export default Loading;

